import { toJalali } from './dateUtils';

/**
 * پارس یکنواخت پاسخ‌های API ماژول Work (مطابق ساختارهای work.txt)
 */

const dig = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
};

/** لیست صفحه‌بندی‌شده — کلیدها به ترتیب اولویت امتحان می‌شوند */
export const parseWorkPaginatedList = (res, paths = []) => {
  const candidates = [
    ...paths,
    'data.data',
    'data.templates.data',
    'data.contracts.data',
    'data.projects.data',
    'data.tasks.data',
    'data',
    'templates.data',
    'contracts.data',
    'projects.data',
    'tasks.data',
  ];

  for (const path of candidates) {
    const block = dig(res, path);
    if (block?.data && Array.isArray(block.data)) {
      return { rows: block.data, total: block.total ?? block.data.length };
    }
    if (Array.isArray(block)) {
      return { rows: block, total: block.length };
    }
  }

  if (Array.isArray(res)) return { rows: res, total: res.length };
  return { rows: [], total: 0 };
};

export const parseContractTemplatesList = (res) =>
  parseWorkPaginatedList(res, ['data']);

export const parseProjectTemplatesList = (res) =>
  parseWorkPaginatedList(res, ['data.templates']);

export const getContractFromResponse = (res) => res?.contract ?? res?.data?.contract ?? null;

export const getContractTemplateFromResponse = (res) =>
  res?.contract ?? res?.template ?? res?.contract_template ?? res?.data?.contract ?? null;

export const getProjectTemplateFromResponse = (res) =>
  res?.template ?? res?.project_template ?? res?.data?.template ?? null;

/** نام دسته الگو — وقتی فقط category_id در پاسخ است */
export const resolveProjectTemplateCategoryName = (tpl, categories = []) => {
  if (!tpl) return '—';
  if (tpl.category?.category_name) return tpl.category.category_name;
  if (tpl.project_category?.category_name) return tpl.project_category.category_name;
  const id = tpl.category_id;
  if (id == null) return '—';
  const found = categories.find((c) => Number(c.id) === Number(id));
  return found?.category_name || '—';
};

export const getProjectFromTabResponse = (res) => res?.project ?? res?.data?.project ?? null;

/** فیلدهای فرم تمدید قرارداد از پاسخ edit/show — تاریخ‌ها شمسی */
export const mapContractRenewToForm = (renew) => {
  if (!renew) return {};
  const startRaw = renew.original_start_date || renew.start_date;
  const endRaw = renew.original_end_date || renew.end_date;
  return {
    amount: renew.amount != null ? Number(String(renew.amount).replace(/,/g, '')) : undefined,
    start_date: startRaw ? toJalali(startRaw) || startRaw : undefined,
    end_date: endRaw ? toJalali(endRaw) || endRaw : undefined,
  };
};

/** فیلترهای ایندکس — مقادیر all برای پارامترهای اجباری API حفظ شوند */
export const WORK_LIST_ALL_PARAMS = {
  contracts: ['client_id', 'contract_type', 'project_id'],
  projects: [
    'status',
    'client_id',
    'category_id',
    'employee_id',
    'team_id',
    'pinned',
    'public',
    'date_filter_on',
  ],
  tasks: [
    'project_id',
    'client_id',
    'assigned_by',
    'assigned_to',
    'status',
    'label_id',
    'priority',
    'category_id',
    'billable',
    'milestone_id',
    'type',
    'pinned',
  ],
  projectTemplates: ['category_id', 'sub_category_id'],
};

export const finalizeWorkListFilters = (api, moduleKey) => {
  const out = { ...api };
  const keepAll = WORK_LIST_ALL_PARAMS[moduleKey] || [];
  keepAll.forEach((key) => {
    if (out[key] === undefined || out[key] === '') out[key] = 'all';
  });
  if (moduleKey === 'projects' && out.progress != null && out.progress !== '' && out.progress !== 'all') {
    out['progress[]'] = out.progress;
    delete out.progress;
  } else if (moduleKey === 'projects') {
    delete out.progress;
  }
  return out;
};
